import { PortalIcon, type PortalIconProps } from './portal-icon';

/** ID card — identity verification step. */
export function IdCardIcon(props: PortalIconProps) {
  return (
    <PortalIcon {...props}>
      <rect x="3" y="5" width="18" height="14" rx="1.5" />
      <rect x="6" y="9" width="4.5" height="5.5" rx="0.8" />
      <path d="M13.5 9.5h4.5M13.5 12.5h4.5M13.5 15.5h2.5" />
    </PortalIcon>
  );
}
